
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Dashboard from "./components/Dashboard";
import Login from "./components/Login";
import MFA from "./components/MFA";

import UserList from "./components/UserManagement/user/List";
import CustomerCompanyList from "./components/UserManagement/customer_company/List";
import UserCompanyAdd from "./components/UserManagement/customer_company/UserCompanyAdd";
import EditCustomer from "./components/UserManagement/customer_company/EditCustomer";


import AddUser from "./components/UserManagement/user/AddUser";
import EditUser from "./components/UserManagement/user/EditUser";

import SetPassword from "./components/SetPassword";
import ForceChangePassword from "./components/ForceChangePassword";
import ForgotPassword from "./components/ForgotPassword";
import ResellerList from "./components/UserManagement/reseller/List";
import ResellerAdd from "./components/UserManagement/reseller/ResellerAdd";
import EditReseller from "./components/UserManagement/reseller/EditReseller";

import Profile from './components/Profile';
import NumberManagement from './components/NumberManagement/Index';
import CreateOrderNumber from './components/NumberManagement/OrderNewNumber/CreateOrder';
import CreateOrderNumberSuccess from './components/NumberManagement/OrderNewNumber/CreateOrderSuccess';
import ViewOrder from './components/NumberManagement/ViewOrder';
import ViewOrderDetail from './components/NumberManagement/ViewOrderDetail';
import ModifyNumber from './components/NumberManagement/ModifyNumber';
import CancelNumber from './components/NumberManagement/CancelNumber';
import InventoryList from './components/NumberManagement/InventoryList';
import RemovedNumbersHistory from './components/NumberManagement/RemovedNumbersHistory';
import ViewTransactions from "./components/NumberManagement/ViewTransactions";
import ViewTrunkDetail from './components/NumberManagement/ViewTrunkDetail';
import EditTrunkDetail from './components/NumberManagement/EditTrunkDetail';
import EditMultipleTrunkDetail from './components/NumberManagement/EditMultipleTrunkDetail';
import TrunkCronSync from './components/NumberManagement/TrunkCronSync';
import FeaturesNumber from './components/NumberManagement/FeaturesNumber';

import DigitMappingList from "./components/NumberManagement/DigitMapping/List";
import AddDigitMapping from "./components/NumberManagement/DigitMapping/AddDigitMapping";
import EditDigitMapping from "./components/NumberManagement/DigitMapping/EditDigitMapping";
import AddMultipleDigitMapping from "./components/NumberManagement/DigitMapping/AddMultipleDigitMapping";

import TrafficAnalyticsReporting from './components/NumberManagement/Report/TrafficAnalyticsReporting';
import RealTimeReportAnalytics from './components/NumberManagement/Report/RealTimeReportAnalytics';
import ReportAnalytics from './components/NumberManagement/Report/ReportAnalytics';
import CDRReportAnalytics from "./components/NumberManagement/Report/CDRAnalytics";

import UptivityAnalytics from "./components/Uptivity/Analytics";
import CitibankUptivityAnalytics from "./components/Uptivity/CitibankUptivityAnalytics";
import InactivityTimeout from "./components/InactivityTimeout";

import ImportInvenotry from "./components/NumberManagement/ImportInventory";
import ImportDIDInventory from "./components/NumberManagement/Imports/ImportDIDInventory";
import ImportsList from "./components/NumberManagement/Imports/Index";
import ImportNoteIntoInventory from "./components/NumberManagement/Imports/ImportNoteIntoInventory";
import ImportInventoryHistory from "./components/NumberManagement/Imports/ImportInventoryHistory";
import ImportNotesIntoInventoryHistory from "./components/NumberManagement/Imports/ImportNotesIntoInventoryHistory";
import ImportNonSupportCarrierNumber from "./components/NumberManagement/Imports/ImportNonSupportCarrierNumber";
import ImportNonSupportCarrierCnam from "./components/NumberManagement/Imports/ImportNonSupportCarrierCnam";
import ImportNonSupportCarrierCnamHistory from "./components/NumberManagement/Imports/ImportNonSupportCarrierCnamHistory";
import ImportSupportCarrierCnam from "./components/NumberManagement/Imports/ImportSupportCarrierCnam";
import ImportSupportCarrierCnamHistory from "./components/NumberManagement/Imports/ImportSupportCarrierCnamHistory";
import ImportNumberRemoveFromPortal from "./components/NumberManagement/Imports/ImportNumberRemoveFromPortal";
import ImportNumberRemoveFromPortalHistory from "./components/NumberManagement/Imports/ImportNumberRemoveFromPortalHistory";
import BulkNumberChangeRoute from "./components/NumberManagement/Imports/BulkNumberChangeRoute";
import CallPassSettings from "./components/NumberManagement/Imports/CallPassSettings";
import ImportCallPassHistory from "./components/NumberManagement/Imports/ImportCallPassHistory";
import CiaNumberSetting from "./components/NumberManagement/Imports/CiaNumberSetting";
import CiaNumberSettingHistory from "./components/NumberManagement/Imports/CiaNumberSettingHistory";
import ImportDoNotOriginate from "./components/NumberManagement/Imports/ImportDoNotOriginate";
import ImportDoNotOriginateHistory from "./components/NumberManagement/Imports/ImportDoNotOriginateHistory";
import ImportNoNumberReputation from "./components/NumberManagement/Imports/ImportNoNumberReputation";
import ImportNoNumberReputationHistory from "./components/NumberManagement/Imports/ImportNoNumberReputationHistory";
import ImportDMTSync from "./components/NumberManagement/Imports/ImportDMTSync";
import ImportDMTSyncHistory from "./components/NumberManagement/Imports/ImportDMTSyncHistory";
import ImportInventoryTags from "./components/NumberManagement/Imports/ImportInventoryTags";
import ImportInventoryTagsHistory from "./components/NumberManagement/Imports/ImportInventoryTagsHistory";
import ImportCallPassDiridTn from "./components/NumberManagement/Imports/ImportCallPassDiridTn";
import ImportCallPassDiridTnHistory from "./components/NumberManagement/Imports/ImportCallPassDiridTnHistory";


import CallPassBrandedCallingSummary from "./components/NumberManagement/CallPassBrandedCalling/CallPassBrandedCallingSummary";
import CallPassBrandedCallingDetails from "./components/NumberManagement/CallPassBrandedCalling/CallPassBrandedCallingDetails";
import CallPassDisplayIdentities from "./components/NumberManagement/CallPassBrandedCalling/CallPassDisplayIdentities";
import CallPassDisplayIdentityDetails from "./components/NumberManagement/CallPassBrandedCalling/CallPassDisplayIdentityDetails";

import TagsSettings from "./components/NumberManagement/TagsSettings";



import ImportDigitMapping from "./components/NumberManagement/DigitMapping/ImportDigitMapping";

import DialedNumberList from "./components/DialedNumber/List";
import CapiLogs from "./components/Capi/Logs";
import CheckDialedNumberStatus from "./components/DialedNumber/CheckDialedNumber";
import ReviewRecordLog from "./components/DialedNumber/ReviewRecordLog";
import TelNumberApiLog from "./components/DialedNumber/TelNumberApiLog";
import TelNumberMonthsDetailLog from "./components/DialedNumber/TelNumberMonthsDetailLog"
import CasDashboard from "./components/CiaDashboard/CasDashboard";
import CiaBatchManagement from "./components/CiaDashboard/CiaBatchManagement";
// import CiaNumberDetail from "./components/CiaDashboard/CiaNumberDetail";
import CiaNumberDetails from "./components/CiaDashboard/CiaNumberDetails";


import Settings from "./components/Settings/Index";
import CarrierSettings from "./components/Settings/CarreirSettings";
import ApplicationSettings from "./components/Settings/ApplicationSettings";
import VPNSettings from "./components/Settings/VPNSettings";
import UptivityIPListSettings from "./components/Settings/UptivityIPListSettings";



import DailyOrderList from "./components/NumberManagement/DailyOrderList";
import ViewDailyOrderDetail from "./components/NumberManagement/ViewDailyOrderDetail";

import CasImageTextRactList from "./components/CiaDashboard/CasImageTextRactList";
import ENRMSSummaryComparison from "./components/CiaDashboard/ResultTrends/ENRMSSummaryComparison";
import ENRMSDeviceComparison from "./components/CiaDashboard/ResultTrends/ENRMSDeviceComparison";
import ENRMSDetailComparison from "./components/CiaDashboard/ResultTrends/ENRMSDetailComparison";

import ENRMSManagement from "./components/ENRMSManagement/Index";
import CarrierManagement from "./components/ENRMSManagement/CarrierManagement";
import GroupManagement from "./components/ENRMSManagement/GroupManagement";
import ResumeManagement from "./components/ENRMSManagement/ResumeManagement";
import DeviceManagement from "./components/ENRMSManagement/DeviceManagement";
import ENRMSSettings from "./components/ENRMSManagement/ENRMSSettings";
import DeviceApiLog from "./components/ENRMSManagement/DeviceApiLog";
import ImageStoreLog from "./components/ENRMSManagement/ImageStoreLog";
import PublishManagement from "./components/ENRMSManagement/PublishManagement";
import ScheduleSummaryList from "./components/ENRMSManagement/ScheduleSummaryList";
import RemoveBatchNumber from "./components/ENRMSManagement/RemoveBatchNumber";
import RemoveBatchNumberHistory from "./components/ENRMSManagement/RemoveBatchNumberHistory";
import SetsManagement from "./components/ENRMSManagement/SetsManagement";
import EnrmsQuickRun from "./components/ENRMSManagement/EnrmsQuickRun";
import ENRMSRegistrationIndex from "./components/ENRMSRegistration/Index";
import ENRMSRegistrationAdmin from "./components/ENRMSRegistration/AdminSetup";
import RegistrationSetup from "./components/ENRMSRegistration/RegistrationSetup";
import ImportTN from "./components/ENRMSRegistration/ImportTN";
import ImportTNHistory from "./components/ENRMSRegistration/ImportTNHistory";
import ExportRegistration from "./components/ENRMSRegistration/ExportRegistration";


import OrderCron from './components/NumberManagement/OrderCron';
import ReconcileActiveNumbers from './components/NumberManagement/ReconcileActiveNumbers';
import ReconcileDisconnectOrders from "./components/NumberManagement/ReconcileDisconnectOrders";
import InventoryExportHistory from './components/NumberManagement/InventoryExportHistory';

import InternationalNumbersOrder from "./components/NumberManagement/InternationalNumbersOrder/OrderNumber";
import CallPassDashboard from "./components/NumberManagement/CallPassBrandedCalling/CallPassDashboard";
import CallPassDisplayIdentityManageTn from "./components/NumberManagement/CallPassBrandedCalling/CallPassDisplayIdentityManageTn";
import TnHistory from "./components/NumberManagement/CallPassBrandedCalling/CallPassDispayIdentities/TnHistory";

const UptivityRoute = ({ element }) => {
    const hasAccess = sessionStorage.getItem('hasUptivityAccess');
    if (hasAccess === 'false') return <Navigate to="/dashboard" replace />;
    return element;
};

const URLS = () => {
  return (
    <BrowserRouter>
    <InactivityTimeout>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/mfa" element={<MFA />} />
        {/* <Route path="/register" element={<Register />} /> */}
        <Route path="/dashboard" element={<Dashboard />} />
        {/* <Route path="/user-management" element={<UserManagement />} /> */}
        <Route path="/user-company/list" element={<CustomerCompanyList />} />
        {/* <Route path="/user-company/:id" element={<ItemDetailComponent />} /> */}
        <Route path="/user-company/edit/:id" element={<EditCustomer />} />
        {/* <Route path="/user-company/review" element={<ReviewCustomer />} /> */}
        <Route path="/user-company-add" element={<UserCompanyAdd />} />
        <Route path="/user-reseller/list" element={<ResellerList />} />
        <Route path="/user-reseller/edit/:id" element={<EditReseller />} />
        <Route path="/user-reseller-add" element={<ResellerAdd />} />
        {/* <Route path="/user-reseller/review" element={<ReviewReseller />} /> */}
        <Route path="/user" element={<UserList />} />
        <Route path="/user-add" element={<AddUser />} />
        <Route path="/user/edit/:id" element={<EditUser />} />
        <Route path="/set-password/:token" element={<SetPassword />} />
        <Route path="/force-change-password" element={<ForceChangePassword />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/profile" element={<Profile />} />
        

        <Route path="/number-management" element={<NumberManagement />} />
        <Route path="/order-new-number" element={<CreateOrderNumber />} />
        <Route path="/features-number" element={<FeaturesNumber />} />
        <Route path="/order-new-number-success" element={<CreateOrderNumberSuccess />} />
        <Route path="/view-order" element={<ViewOrder />} />
        <Route path="/view-order-detail/:id" element={<ViewOrderDetail />} />
        <Route path="/modify-number" element={<ModifyNumber />} />
        <Route path="/cancel-number" element={<CancelNumber />} />
        <Route path="/inventory" element={<InventoryList />} />
        <Route path="/view-transactions" element={<ViewTransactions />} />       
        <Route path="/view-trunk-detail/:id" element={<ViewTrunkDetail />} />
        <Route path="/edit-trunk-detail/:id" element={<EditTrunkDetail />} />
        <Route path="/edit-multiple-trunk-detail" element={<EditMultipleTrunkDetail />} />                
        <Route path="/trunk-cron-list" element={<TrunkCronSync />} />

        <Route path="/reconcile-active-numbers" element={<ReconcileActiveNumbers />} />
        <Route path="/reconcile-disconnect-orders" element={<ReconcileDisconnectOrders />} />
        <Route path="/inventory-export-history" element={<InventoryExportHistory />} />
        {/* BCP-32: every inventory removal, whichever entry point was used */}
        <Route path="/removed-numbers-history" element={<RemovedNumbersHistory />} />


        <Route path="/imports-list" element={<ImportsList />} />
        <Route path="/import-inventory" element={<ImportInvenotry />} />
        <Route path="/import-inventory-history" element={<ImportInventoryHistory/>}/>
        <Route path="/import-notes-into-inventory-history" element={<ImportNotesIntoInventoryHistory/>}/>
        <Route path="/import-did-inventory" element={<ImportDIDInventory/>}/>
        <Route path="/import-note-into-inventory" element={<ImportNoteIntoInventory/>}/>
        <Route path="/import-non-supported-carrier-cnam" element={<ImportNonSupportCarrierCnam/>}/>
        <Route path="/import-non-supported-carrier-cnam-history" element={<ImportNonSupportCarrierCnamHistory/>}/>
        <Route path="/import-supported-carrier-cnam" element={<ImportSupportCarrierCnam/>}/>
        <Route path="/import-supported-carrier-cnam-history" element={<ImportSupportCarrierCnamHistory/>}/>
        <Route path="/import-portal-number-remove" element={<ImportNumberRemoveFromPortal/>}/>
        <Route path="/import-portal-number-remove-history" element={<ImportNumberRemoveFromPortalHistory/>}/>
        <Route path="/bulk-number-change-route" element={<BulkNumberChangeRoute />} />
        <Route path="/call-pass-settings" element={<CallPassSettings />} />
        <Route path="/import-call-pass-history" element={<ImportCallPassHistory />} />
        <Route path="/import-do-not-originate" element={<ImportDoNotOriginate/>}/>
        <Route path="/import-do-not-originate-history" element={<ImportDoNotOriginateHistory/>}/>
        <Route path="/import-no-number-reputation" element={<ImportNoNumberReputation/>}/>
        <Route path="/import-no-number-reputation-history" element={<ImportNoNumberReputationHistory/>}/>
        <Route path="/import-dmt-sync" element={<ImportDMTSync/>}/>
        <Route path="/import-dmt-sync-history" element={<ImportDMTSyncHistory/>}/>
        <Route path="/import-inventory-tags" element={<ImportInventoryTags/>}/>
        <Route path="/import-inventory-tags-history" element={<ImportInventoryTagsHistory/>}/>
        <Route path="/import-call-pass-dirid-tn" element={<ImportCallPassDiridTn/>}/>
        <Route path="/import-call-pass-dirid-tn-history" element={<ImportCallPassDiridTnHistory/>}/>

        <Route path="/call-pass" element={<CallPassDashboard/>} />
        <Route path="/call-pass-summary" element={<CallPassBrandedCallingSummary />} />
        <Route path="/call-pass-branded-calling-details" element={<CallPassBrandedCallingDetails />} />
        <Route path="/call-pass-display-identities" element={<CallPassDisplayIdentities />} />
        <Route path="/call-pass-display-identity-details" element={<CallPassDisplayIdentityDetails/>}/>
        <Route path="/call-pass-display-identity-tn-manage" element={<CallPassDisplayIdentityManageTn/>}/>
        <Route path="/call-pass-display-identities/tn/history" element={<TnHistory/>}/>
        

        <Route path="/digit-mapping" element={<DigitMappingList />} />
        <Route path="/digit-mapping/add" element={<AddDigitMapping />} />
        <Route path="/digit-mapping/edit/:id" element={<EditDigitMapping />} />
        <Route path="/digit-mapping/import" element={<ImportDigitMapping />} />
        <Route path="/digit-mapping/add-multiple" element={<AddMultipleDigitMapping />} />
        <Route path="/traffic-and-analytics-reporting" element={<ReportAnalytics />} />
        <Route path="/resource-report" element={<TrafficAnalyticsReporting />} />
        <Route path="/real-time-report" element={<RealTimeReportAnalytics />} />
        <Route path="/cdr-report" element={<CDRReportAnalytics />} />
        <Route path="/uptivity" element={<UptivityRoute element={<UptivityAnalytics />} />} />
        <Route path="/citibank-uptivity" element={<UptivityRoute element={<CitibankUptivityAnalytics />} />} />
        <Route path="/cas-management" element={<CasDashboard/>}/>
        {/* <Route path="/cia-batch-management" element={<CiaBatchManagement/>}/> */}
        <Route path="/cia-number-detail" element={<CiaNumberDetails/>}/>
        <Route path="/cia-number-details" element={<CiaNumberDetails/>}/>
        <Route path="/cia-number-setting" element={<CiaNumberSetting/>}/>
        <Route path="/cia-number-setting-history" element={<CiaNumberSettingHistory/>}/>
        <Route path="/dialed-number/list" element={<DialedNumberList />} />
        <Route path="/capi/logs" element={<CapiLogs />} />
        <Route path="/check-dialed-number-status" element={<CheckDialedNumberStatus />} />
        <Route path="/review-record-log" element={<ReviewRecordLog />} />
        <Route path="/tel-number-api-log" element={<TelNumberApiLog />} />
        <Route path="/tel-number-months-detail-log" element={<TelNumberMonthsDetailLog />} />

        <Route path="/import-non-support-carrier-number" element={<ImportNonSupportCarrierNumber />} />

        <Route path="/settings" element={<Settings />} />
        <Route path="/application-settings" element={<ApplicationSettings />} />
        <Route path="/carrier-settings" element={<CarrierSettings />} />
        <Route path="/vpn-settings" element={<VPNSettings />} />
        <Route path="/uptivity-ip-list" element={<UptivityIPListSettings />} />
        <Route path="/tags-settings" element={<TagsSettings />} />
      
        <Route path="/daily-order-list" element={<DailyOrderList />} />
        <Route path="view-daily-order-detail/:id" element={<ViewDailyOrderDetail />} />


        {/* <Route path="*" element={<NotFound />} /> */}
        {/* <Route path="/cas-platform-setup" element={<CasPlatformSetup />} /> */}
        <Route path="/cas-image-texttact" element={<CasImageTextRactList />} />
        <Route path="/enrms-summary-comparison" element={<ENRMSSummaryComparison />} />
        <Route path="/enrms-device-comparison" element={<ENRMSDeviceComparison />} />
        <Route path="/enrms-detail-comparison" element={<ENRMSDetailComparison />} />

        <Route path="/enrms-management" element={<ENRMSManagement />} />
        <Route path="/enrms-carrier-management" element={<CarrierManagement />} />
        <Route path="/enrms-settings" element={<ENRMSSettings />} />
        <Route path="/enrms-group-management" element={<GroupManagement />} />
        <Route path="/enrms-resume-management" element={<ResumeManagement />} />
        <Route path="/enrms-device-management" element={<DeviceManagement />} />
        <Route path="/enrms-device-api-log" element={<DeviceApiLog/>}/>
        <Route path="/enrms-image-api-log" element={<ImageStoreLog/>}/>
        <Route path="/enrms-publish-management" element={<PublishManagement />} />
        <Route path="/enrms-schedule-summary" element={<ScheduleSummaryList />} />
        <Route path="/enrms-remove-batch-number" element={<RemoveBatchNumber/>}/>
        <Route path="/enrms-remove-batch-number-history" element={<RemoveBatchNumberHistory/>}/>
        <Route path="/enrms-sets-management" element={<SetsManagement />} />
        <Route path="/enrms-quick-run" element={<EnrmsQuickRun />} />
        <Route path="/enrms-registration" element={<ENRMSRegistrationIndex />} />
        <Route path="/enrms-registration-admin" element={<ENRMSRegistrationAdmin />} />
        <Route path="/enrms-registration-setup" element={<RegistrationSetup />} />
        <Route path="/enrms-registration-import" element={<ImportTN />} />
        <Route path="/enrms-registration-import-history" element={<ImportTNHistory />} />
        <Route path="/enrms-registration-export" element={<ExportRegistration />} />
        
        {/* Order review cron url */}
        <Route path="/order-verification-list" element={<OrderCron />} />

        <Route path="/international-numbers-order" element={<InternationalNumbersOrder />} />
        </Routes>
        </InactivityTimeout>
    </BrowserRouter>
  );
}

// function DashboardWithNavbar() {
//   return (
//     <>
//       <Dashboard />
//     </>
//   );
// }
 
export default URLS;